import { useAuth0 } from "@auth0/auth0-react";
import Action from "components/ActionPopOver";
import MainDialog from "components/Dialog/MainDialog";
import { formatDate, numberFormat } from "helper";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { PayNow } from "store/redux/actions/index";
import FinanceService from "../../../Lib/API/Finance";
import { SetRecurringChecks } from "../../../app/redux/actions/index";
import AlertDialog from "../../../components/Dialog";
import MyModal from "../../../components/MyModal";
import NewCharge from "../../../pages/NewFinance/NewCharge";
import UserContext from "../../../pages/NewFinance/NewChargeContext";

export const Charge = ({ data, onReversalClick, batchTable, onSharePaymentLinkClick, viewDocumentHandler,
  downloadFileHandler,
  documentHandler,
 onPaymentSuccess,
 hideActions,
 hideDelete = false,
 hidePayNow = false,
 hideSharePaymentLink = false,
 disableActionButton = false,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState([]);
  const dispatch = useDispatch();
const [invoiceData, setInvoiceData] = useState(null);
const [receiptData, setReceiptData] = useState(null);

const fetchDocumentByTransactionId = async (id, type) => {
  const token = await getAccessTokenSilently();

  try {
    const res = await FinanceService.getDocumentByTransactionId(
      token,
      id,
      type
    );

    const result = res?.result?.[0];

    if (type === "invoice") {
      setInvoiceData(result);
    }

    if (type === "receipt") {
      setReceiptData(result);
    }

  } catch (err) {
    toastr.error("Error", err?.data?.message);
  }
};

useEffect(() => {
 
  if (data?.charge?.status === "payment") {
    fetchDocumentByTransactionId(data?._id, "invoice");
    fetchDocumentByTransactionId(data?.charge?._id, "receipt");
  }
}, [data]);

  const fetchReversalTypes = async (type) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getAllReversalTypes(type, token)
      .then((res) => {
        setActionTypes(res?.result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });

    setReversalActionTypes(true);
  };
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
    setOpenCancleModalDialog(false);
  };
  const onChargeEditClick = (row) => {
    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
  };

  const [openModalDialog, setOpenModalDialog] = React.useState(false);
  const [showWarningDeleteDialog, setShowWarningDeleteDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openCancleModalDialog, setOpenCancleModalDialog] = React.useState(false);
  const [recurringAction, setRecurringAction] = useState("");
  const [confirmClose, setConfirmClose] = useState(false);

  useEffect(() => {
    if (recurringAction === "") return;
    onSelectedPayment(data, recurringAction)
  }, [recurringAction])

  const onCancelClick = async () => {
    setOpenCancleModalDialog(true);
  }

  const handelSubmit1 = () => {
    setRecurringAction("disable");
  }

  const onDeleteClick = async (row) => {
    const isZeroPaid = parseFloat(row?.charge?.paid) === 0;
    const isReversed = row?.charge?.sub_status === "reversal" || row?.charge?.payment?.status === "reversal";
    setSelectedRow(row);
    if (isZeroPaid && isReversed) {
      setShowWarningDeleteDialog(true);
    } else {
      setOpenModalDialog(true);
    }
  }

  const onSelectedPayment = async (row) => {
    const payload = {
      "transactionId": data?._id ?? "64620154b09a58002fc35dd2",
      "status": recurringAction
    }
    const token = await getAccessTokenSilently();
    await FinanceService.PaymentInfoAction(payload, token).then((res) => {
      // setPaymentAction(true);
      setOpenCancleModalDialog(false);
   
      toastr.success(res.message ?? "Action Successfully Completed!");
    }).catch((error) => {
      // setPaymentAction(true);
      toastr.error(error?.data?.message);
    });
  }

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();

    await FinanceService.deleteTransaction(selectedRow, token, selectedRow?.charge?._id ?? "")
      .then((res) => {
        if (res) {
          toastr.success("Transaction deleted successfully");
          setOpenModalDialog(false);
          setShowWarningDeleteDialog(false);
        }
      })
      .catch((err) => {
        toastr.error(err?.data?.message);
        setOpenModalDialog(false);
        setShowWarningDeleteDialog(false);
      });
  };

  const original_amount = 
    data?.discount
      ? data?.discount_type === "%"
        ? data?.discount === 100
          ? data?.originalAmount 
          : data?.total_amount / (1 - data?.discount / 100)
        : data?.total_amount + data?.discount
      : data?.total_amount;

  const [reponse, setResponse] = useState({});
  const [open, setOpen] = useState(false);
  const [isSaved, setSaved] = useState(false);
  const [hfinish, setHFinish] = useState(false);
  const [stepOne, setStepOne] = useState(true);
  const [stepper, setStepper] = useState("New Charge");
  const [accountTransactionModal, setAccountTransactionModal] = useState(false);
  const [batchList, setbatchList] = useState(false);

  const closeModal = () => {
    setStepOne(true);
    setOpen(false);
    setAccountTransactionModal(false);
  };

  const onModalClose = () => {
    if (isSaved || hfinish) {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
     
    } else {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
    }
  if (onPaymentSuccess) {
    onPaymentSuccess();
  }
  };

  const onPayNowClick = (row) => {
    dispatch(PayNow({ detail: row }));
    setResponse({
      ...data,
      type: "pay-now",
    });

    setOpen(true);
    window.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  };


  const displayInstallmentStatus = (data) => {
    const status = data?.charge?.installmentDetails?.status;
    switch (status) {
      case "active":
       return "Active";
      case "disable":
        return "Disabled";
      case "on-hold":
        return "On-hold";
      case "completed":
        return "Completed";
      default:
        return "Active";
    }
  }
  const displayRecurringStatus = (data) => {
    const status = data?.recurringDetails?.recurringStatus;
    switch (status) {
      case "active":
        return "Active";
      case "declined":
        return "Declined";
      case "on-hold":
        return "On-hold";
      case "disable": 
        return "Disabled";
      default:
        return "";
    }
  }

  const closeFinanceModal = () => {
    setConfirmClose(true);
  }

  const confirmCloseFinanceModal = () => {
    setConfirmClose(false);
    onModalClose();
  }

  

  return (
    <div className="">
      <div className="drawer-header">
        <div className="cursor-pointer">
          {(batchTable === "batchtable" || hideActions) ? <></> : <Action
            style={{ width: "16px" }}
            action="finance"
            actionDrawer="drawer"
            chargeStatus={
              data?.charge?.amount -
                data?.charge?.paid +
                data?.charge?.discount >
                0 &&
                data?.charge?.amount -
                data?.charge?.paid +
                data?.charge?.discount <
                data?.charge?.amount
                ? "partially_paid"
                : data?.charge?.payment?.status
            }
            drawerBol={true}
            onChargeEditClick={() => {
              onChargeEditClick(data)
            }}
            onPayClick={hidePayNow ? undefined : () => { onPayNowClick(data); }}
            onSharePymentClick={hideSharePaymentLink ? undefined : () => { onSharePaymentLinkClick(data); }}
            onUpdatePaymentClick={() => {
              onChargeEditClick(data);
            }}
            hideInvoiceButtons={!invoiceData}
            hideReceiptButtons={!receiptData}
            onReversalClick={() =>
              fetchReversalTypes(
                data?.charge?.status === "charge"
                  ? "charge"
                  : data?.charge?.status === "payment"
                    ? "payment"
                    : ""
              )
            }
            onDeleteClick={hideDelete ? undefined : () => { onDeleteClick(data) }}
            onCancelClick={() => {
              onCancelClick()
            }}
            OnRecurringAction={setRecurringAction}
            disableActionButton={disableActionButton}
            row={data}
            setReceiptFile={() => {
  if (receiptData?._id) {
    viewDocumentHandler(receiptData._id);//check this once
  }
}}

setInvoiceFile={() => {
  if (invoiceData?._id) {
    viewDocumentHandler(invoiceData._id);
  }
}}

setReceiptDownload={() => {
  if (receiptData) {
    downloadFileHandler(receiptData);
  }
}}

setInvoiceDownload={() => {
  if (invoiceData) {
    downloadFileHandler(invoiceData);
  }
}}

setShareInvoicePDF={() => {
  if (invoiceData) {
    documentHandler(invoiceData);
  }
}}

setShareReceiptPDF={() => {
  if (receiptData) {
    documentHandler(receiptData);
  }
}}

          />}
          <MainDialog
            open={reversalActionTypes}
            getTypes={getTypes ?? []}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setReversalActionTypes(false);
            }}
            onAccept={(id, type, hidden) =>
              onReversalClick(
                data?.charge?.status === "charge"
                  ? {
                    reversal_type: {
                      id: id,
                      type: type,
                      hidden: hidden,
                    },
                    chargeId: data.charge?._id,
                  }
                  : "",
                setReversalActionTypes
              )
            }
            content={"Choose a reversal type"}
          />
        </div>
      </div>
      {data?.charge?.payment?.status === "declined" && <>
        <div className="drawer-title">PAYMENT DECLINED</div>
        <div className="drawer-content ">
          <div className="first-pr">
            <p className="drawer-row">
              <div className="">Decline Type</div>
              <div className="value" title={'Decline Type'}>
                {"Card Expired"}
              </div>
            </p>
          </div>
          <hr className="my-5" />
        </div>
      </>
      }
      {data?.charge?.isInstallment && (
        <>
        <div className="drawer-title">
          Installments
        </div>
        <div className="drawer-content ">
          <div className="first-pr">
            <p className="drawer-row">
              <div className="">amount</div>
              <div className="value">
                {numberFormat({number:data?.charge?.installmentDetails?.amount, decimal:2, style: 'currency'})}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">installments</div>
              <div className="value">
                {data?.charge?.installmentDetails?.cycle}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Paid</div>
              <div className="value">
                {numberFormat({number:data?.charge?.installmentDetails?.paid, decimal:2, style: 'currency'})}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Payment starts</div>
              <div className="value">
                {formatDate({date:data?.charge?.installmentDetails?.installmentStart, formatType: "defaultWithUTC"})}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Status</div>
              <div className="value">
                {displayInstallmentStatus(data)}
              </div>
            </p>
          </div>
        </div>
        </>
      )}
      {data?.isRecurring && (
        <>
        <div className="drawer-title">
          Recurring
        </div>
        <div className="drawer-content ">
          <div className="first-pr">
            <p className="drawer-row">
              <div className="">Status</div>
              <div className="value">
                {displayRecurringStatus(data)}
              </div>
            </p>
          </div>
        </div>
        </>
      )}
      <div className="drawer-title">
        {data?.charge_type === "charge"
          ? "Charge"
          : data?.charge_type === "credit_on_account"
            ? "Credit On Account"
            : "Charge"}{" "}
        info
      </div>
      <div className="drawer-content ">
        <div className="first-pr">
          <p className="drawer-row">
            <div className="">Charge#</div>
            <div className="value" title={data?.charge?._id}>
              {data?.charge?._id ? data?.charge?._id : "-"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Amount</div>
            <div className="value">
              {numberFormat({number:(+data?.charge?.amount + data?.charge?.discount), decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Paid</div>
            <div className="value">
              {numberFormat({number:+data?.charge?.paid, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Due</div>
            <div className="value">
              {numberFormat({number:
                  (
                    +data?.charge?.amount +
                    data?.charge?.discount -
                    data?.charge?.paid
                  ), decimal:2, style: "currency"}
                )}
            </div>
          </p>

          <p className="drawer-row">
            <div className="">Discount</div>
            <div className="value">
              {numberFormat({number:data?.charge?.discount ?? 0, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Due Date</div>
            <div className="value">
              {formatDate({date:data?.charge?.due_date, formatType: "defaultWithUTC"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Convenience fee</div>
            <div className="value">
              {numberFormat({number:data?.charge?.payment?.convenient_fee, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Status</div>
            <div className="value">{data?.charge?.status}</div>
          </p>
          <p className="drawer-row">
            <div className="">Sync info</div>
            <div className="value">
              {data?.charge?.is_synced
                ? data?.charge?.synced_Batch
                : "Not synced"}
            </div>
          </p>
        </div>
        <hr className="my-5" />
        <div className="drawer-title">Transaction info</div>
        <div className="first-pr">
          <p className="drawer-row">
            <div className="">Transaction#</div>
            <div className="value" title={data?._id}>
              {" "}
              {data._id ? data._id : "-"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Split</div>
            <div className="value">
              {data?.is_splitted ? data?.number_of_split : "No"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Original Amount</div>
            <div className="value">
              {numberFormat({number:+original_amount, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Discount</div>
            <div className="value">
              {numberFormat({number:data?.discount ?? 0, decimal:2, style: data?.discount_type === "%" ? "decimal" : "currency"})}
              {data?.discount_type === "%" ? "%" : ""}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Total Amount</div>
            <div className="value">
              {numberFormat({number:+data?.total_amount, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Convenience fee</div>
            <div className="value">
              {numberFormat({number:data?.charge?.payment?.convenient_fee, decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Total paid</div>
            <div className="value">
              {numberFormat({number:(+data?.total_paid ? data?.total_paid : 0), decimal:2, style: "currency"})}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Status</div>
            <div className="value">{data?.charge?.status}</div>
          </p>
          <p className="drawer-row">
            <div className="">Created Date</div>
            <div className="value">
              {data?.createdAt ? formatDate({ date: data?.createdAt, formatType: "defaultWithUTC" }) : "-"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Source</div>
            <div className="value">{data?.source || "-"}</div>
          </p>
          <p className="drawer-row">
            <div className="drawer-row">Ledger Account</div>
            <div className="value">
              {data?.Ledger?.name} / {(data?.SubLedger?.name && data?.SubLedger?.name !== "N/A") ? data?.SubLedger?.name : "-"}{" "}
            </div>
          </p>
        </div>

        <hr className="my-5" />

        <div className="second-pr">
          <>
            <p className="drawer-row mt-5">
              <div className="">{data?.comment_invoice?.note}</div>
            </p>
          </>
        </div>
      </div>

      {(data) && (
        <MyModal
          className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
          open={open}
          onClose={closeFinanceModal}
        >
          <UserContext.Provider value={{ hfinish, setHFinish }}>
            <NewCharge
              setStepOne={setStepOne}
              setStepper={setStepper}
              handleClose={onModalClose}
              data={data}
              // data={accountTransactionModal ? "" : PayNowData?.detail}
              activeIndex={accountTransactionModal ? 0 : 1}
              setSaved={setSaved}
              setBatchList={setbatchList}
            />
          </UserContext.Provider>
        </MyModal>
      )}


      <AlertDialog
        open={openModalDialog}
        handleClose={() => setOpenModalDialog(false)}
        onDecline={() => {
          setOpenModalDialog(false);
        }}
        onAccept={() => {
          handleSubmit();
        }}
        title="Are you sure?"
        description={"Deleting this transaction is non-reversible. would you like to proceed?"}
      />
      <AlertDialog
        open={showWarningDeleteDialog}
        onDecline={() => setShowWarningDeleteDialog(false)}
        onAccept={() => handleSubmit()}
        acceptBtnText="Delete"
        title="Delete Charge"
        description={
          <div style={{ textAlign: "left", color: "#002E5C" }}>
            <p style={{ marginBottom: "10px", fontWeight: "700" }}>This charge is already paid, reversed, or synced.</p>
            <p style={{ marginBottom: "10px" }}>Deleting it here will not update your accounting records in your accounting system.</p>
            <p style={{ marginBottom: "20px" }}>You are responsible for making any necessary changes directly in your accounting system.</p>
            <p style={{ fontWeight: "700" }}>Are you sure you want to delete this charge?</p>
          </div>
        }
      />
      <AlertDialog
        open={openCancleModalDialog}
        onDecline={() => {
          setOpenCancleModalDialog(false);
        }}
        onAccept={() => {
          handelSubmit1()
          // onSelectedPayment(row);
        }}
        title={"Are you sure?"}
      />

      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseFinanceModal}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};